import openPositionsJson from '../../../public/openPositions.json'

const DATA = openPositionsJson

export default DATA


// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/openPositionsData.js